import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isEmptyField, isInvalidEmail } from '../../../utils';
import { useToast, useSession } from '../../../hooks';
import { recoverPassword  } from '../../../services';
import { Button, Input } from '../../../components';
import { AuthLayout } from '../../../components/layouts';
import { Container } from './styles';

type FormData = {
    email?: string;
}

type FormError = {
    field: string;
    message: string;
}

const RecoverPasswordPage: React.FC = () => {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const { handleRequest } = useSession();
    const [data, setData] = useState<FormData>({});
    const [errors, setErrors] = useState<FormError[]>([]);

    const handleChange = useCallback((newData: FormData) => setData(oldData => ({
        ...oldData,
        ...newData
    })), []);

    const validateData = useCallback(() => {
        const { email } = data;

        setErrors([]);

        let error: boolean = false;
        
        if (isEmptyField(email)) {
            setErrors(oldErrors => [...oldErrors, {
                field: 'email',
                message: 'Campo obrigatório'
            }]);
            error = true;
        } else if (isInvalidEmail(email)) {
            setErrors(oldErrors => [...oldErrors, {
                field: 'email',
                message: 'E-mail inválido'
            }]);
            error = true;
        }

        return error;
    }, [data]);

    const handleRecoverPassword = useCallback(async () => {
        if (!validateData()) {
            const { email } = data;

            if (!email)
                throw new Error('The state email cannot be null');

            const response = await handleRequest(async () => {
                await recoverPassword({
                    email,
                });
            });

            if (response.success) {
                showToast({
                    type: 'success',
                    message: 'Uma senha temporária foi enviada ao seu e-mail'
                });

                navigate('/', {
                    replace: true,
                    state: {
                        email,
                    }
                });
            }
        }
    }, [navigate, showToast, validateData, handleRequest, data]);

    return (
        <AuthLayout>
            <Container>
                <form>
                    <Input
                        id="recoverpassword.email"
                        type="email"
                        label="E-mail"
                        placeholder="Digite seu e-mail"
                        error={errors.filter(({ field }) => field === 'email')[0]?.message}
                        onChange={e => handleChange({
                            email: e.target.value
                        })}
                    />
                </form>
                <Button
                    id="recoverpassword.recoverbutton"
                    onClick={handleRecoverPassword}
                >
                    Recuperar senha
                </Button>
            </Container>
        </AuthLayout>
    );
};
export { RecoverPasswordPage };